import defaultState from './state'
import Vue from 'vue'

export default {
  addCategory: (state, payload) => {
    state.categories.push(payload)
  },
  updateCategory: (state, payload) => {
    const categoryIndex = state.categories.findIndex(el => el.id === payload.id)
    if (categoryIndex > -1) {
      state.categories.splice(categoryIndex, 1, payload)
    }
  },
  removeCategory: (state, payload) => {
    const categoryToRemoveIndex = state.categories.findIndex(el => el.id === payload)
    if (categoryToRemoveIndex > -1) {
      state.categories.splice(categoryToRemoveIndex, 1)
    }
  },
  addSubCategory: (state, payload) => {
    state.categories.forEach(category => {
      if (payload.defaultCategoryOffice.id === category.id) {
        category.customCategories.push(payload)
      }
    })
  },
  removeSubcategory: (state, payload) => {
    const parentCategoryIndex = state.categories.findIndex(el => el.id === payload.defaultCategoryOffice.id)
    if (parentCategoryIndex > -1) {
       const subcategoryIndex = state.categories[parentCategoryIndex].customCategories.findIndex(el => el.id === payload.id)
       if (subcategoryIndex > -1) {
        state.categories[parentCategoryIndex].customCategories.splice(subcategoryIndex, 1)
       }
    }
  },

  setCategories: (state, payload) => {
    if (state.currentPage === 1) {
      state.categories = payload
    } else {
      state.categories.push(...payload)
    }
  },
  setCustomCategories: (state, payload) => {
    if (state.currentPage === 1) {
      state.customCategories = payload
    } else {
      state.customCategories.push(...payload)
    }
  },
  setDefaultCategoriesOffice: (state, payload) => {
    if (state.currentPage === 1) {
      state.defaultCategoriesOffice = payload
    } else {
      state.defaultCategoriesOffice.push(...payload)
    }
  },
  setUserRecentCategories: (state, payload) => {
    state.userRecentCategories = [...payload]
  },
  setCategoriesFilters: (state, payload) => { state.filters = payload },
  setCategoriesLastPage: (state, payload) => {
    state.lastPage = payload
  },
  incrementCategoriesCurrentPage: (state, payload) => {
    state.currentPage++
  },
  setIsCallingCategories: (state, payload) => { state.setIsCallingCategories = payload },
  clearStoreData: (state) => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }
}
